<template>
  <div class="comment-item" @mouseenter="showHideExtra" @mouseleave="showHideExtra" :class="{ 'commentText ': !replyToId, 'replyText': replyToId }" v-observe-visibility="{
    callback: visibilityChanged,
    once: true,
  }">
    <!-- MODAL - delete creative -->
    <md-dialog :md-active.sync="deleteConfirmDialogOpen" v-if="commentToBeDeleted" @md-clicked-outside="onCancel">
      <md-dialog-title>
        <span>Comment delete</span>
        <button class="btn btn--close" @click="onCancel"></button>
      </md-dialog-title>
      <div class="confirm__content">
        <div class="text">Are you sure you want to delete your comment?</div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-button class="md-primary modal-cancel-btn" @click="onCancel">Cancel</md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="deleteComment(commentToBeDeleted)">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <div class="replyBorder" :usertype="comment.user.user_type">
      <svg class="commentMarker" v-if="comment.x_position != 0 || comment.y_position != 0" @click="showMarker"
        :class="{ 'active': $store.state.view_comment.id == comment.id }" width="20" height="20" viewBox="0 0 20 20"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.188 8C12.188 9.23047 11.2036 10.1875 10.0005 10.1875C8.77002 10.1875 7.81299 9.23047 7.81299 8C7.81299 6.79688 8.77002 5.8125 10.0005 5.8125C11.2036 5.8125 12.188 6.79688 12.188 8ZM10.0005 7.125C9.5083 7.125 9.12549 7.53516 9.12549 8C9.12549 8.49219 9.5083 8.875 10.0005 8.875C10.4653 8.875 10.8755 8.49219 10.8755 8C10.8755 7.53516 10.4653 7.125 10.0005 7.125ZM15.2505 8C15.2505 10.4062 12.0513 14.6445 10.6294 16.4219C10.3013 16.832 9.67236 16.832 9.34424 16.4219C7.92236 14.6445 4.75049 10.4062 4.75049 8C4.75049 5.10156 7.07471 2.75 10.0005 2.75C12.8989 2.75 15.2505 5.10156 15.2505 8ZM10.0005 4.0625C7.81299 4.0625 6.06299 5.83984 6.06299 8C6.06299 8.35547 6.17236 8.875 6.47314 9.58594C6.74658 10.2422 7.15674 11.0078 7.62158 11.7734C8.41455 13.0312 9.31689 14.2344 10.0005 15.1094C10.6567 14.2344 11.5591 13.0312 12.3521 11.7734C12.8169 11.0078 13.2271 10.2422 13.5005 9.58594C13.8013 8.875 13.938 8.35547 13.938 8C13.938 5.83984 12.1606 4.0625 10.0005 4.0625Z"
          fill="#367CFF" />
      </svg>
      <svg class="commentMarker" v-if="comment.comment_attachment" @click="showDraw"
        :class="{ 'active': $store.state.view_comment.id == comment.id }" width="20" height="20" viewBox="0 0 20 20"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.25049 9.96875C8.25049 9.14844 8.6333 8.38281 9.28955 7.89062L15.77 3.02344C16.2622 2.64062 16.9731 2.69531 17.438 3.10547C17.9028 3.54297 17.9849 4.25391 17.6567 4.80078L13.2271 11.6367C12.8169 12.2656 12.1333 12.7031 11.395 12.8125L8.25049 9.96875ZM10.8755 13.6875C10.8755 15.3828 9.48096 16.75 7.81299 16.75H3.87549C3.3833 16.75 3.00049 16.3672 3.00049 15.875C3.00049 15.4102 3.3833 15 3.87549 15H3.98486C4.47705 15 4.80518 14.5078 4.75049 14.0156C4.75049 13.9062 4.75049 13.7969 4.75049 13.6875C4.75049 12.0469 6.03564 10.707 7.67627 10.6523L10.8481 13.4961C10.8481 13.5508 10.8755 13.6328 10.8755 13.6875Z" fill="#367CFF"/>
      </svg>

      <!--<img alt="Comment Marker" :class="{'active': $store.state.view_comment == comment }"
         v-if="comment.x_position != 0 || comment.y_position != 0" @click="mouseEnter" class="commentMarker"
         src="@/assets/icons/markeDarkr.svg"/>-->
      <div>
        <div class="commentTitle">
          <span class="sentCommentersName">{{ comment.user.name }}</span>, {{ comment.created_at }}
        </div>

        <div v-if="comment.comment_attachment && false" style="display: flex;align-items: center;justify-content: center;">
          <div v-for="i in comment.comment_attachment" :key="i.id"
            style="padding: 5px;position:relative;cursor: pointer">
            <a download="attachment" :href="i.data" target="_blank"><img :src="i.data"
                @click="selectedAttachment = i.data; showAttachment = true;" /></a>
          </div>
        </div>



        <div v-if="!editMessage" :class="'commentSentText '" v-html="nl2br(comment.message)"></div>
      </div>
      <!-- EDIT MSG -->
      <div v-if="editMessage">
        <!--<div style="display: flex;
    align-items: center;
    justify-content: center;">
        <div  v-for="(i,index) in pastedImage" :key="index" style="padding: 5px;position:relative">
          <button @click="deleteImg(index)" style="position: absolute; top:0; right: 0; background-color: #eee; transform: scale(0.5); transform-origin: top right" class="btn btn--close"></button>
          <img  :src="i" />
        </div>
      </div>-->
        <textarea placeholder="Add comment here..." class="textarea margin-small--bottom"
          v-model="editMessage"></textarea>
        <div class="d-flex textarea-buttons">
          <a class="hrefButton--black" @click="editMessage = undefined">Cancel</a>
          <button class="btn btn-blue" @click="updateComment()">Save</button>
        </div>
      </div>

      <!-- Edit, delete buttons -->
      <div class="row ">
        <div class="comment-item__buttons">
          <a v-if="$store.state.user.id === comment.user.id & !replyToId & !editMessage & comment.creative.status !== 'done' &&
            (($store.state.user.user_type == 'client' && comment.creative.comment_status == 'client') ||
              ($store.state.user.user_type == 'account' && comment.creative.comment_status == 'account')) &&
            comment.status != 'close' && comment.creative.parent_id == 0" class="hrefButton--blue margin-small--right"
            href="#" @click="editMessage = comment.message">Edit</a>
          <a v-if="$store.state.user.id === comment.user.id & !replyToId & !editMessage & comment.creative.status !== 'done' &&
            (($store.state.user.user_type == 'client' && comment.creative.comment_status == 'client') ||
              ($store.state.user.user_type == 'account' && comment.creative.comment_status == 'account')) &&
            comment.status != 'close' && comment.creative.parent_id == 0" class="hrefButton--blue margin-small--right"
            href="#" @click="commentToBeDeleted = comment.id; deleteConfirmDialogOpen = true">Delete</a>
        </div>
      </div>
    </div>
    
    <div>
      <comment class="commentText-replyText" v-for="(c, i) in comment.replies" :key="c.id" :comment="c" :reply="false"
        :index="i" />
      <a v-if="reply & !replyToId & !editMessage & comment.creative.status !== 'done' &&
        comment.status != 'close' && comment.creative.parent_id == 0 && $store.state.user.user_type == comment.creative.comment_status"
        class="hrefButton margin-small--right reply-btn" :class="[{ 'reply-margin': comment.replies && comment.replies.length > 0 }, {
          'reply-margin-top': $store.state.user.id === comment.user.id && ((($store.state.user.user_type == 'client' && comment.creative.comment_status == 'client') ||
            ($store.state.user.user_type == 'account' && comment.creative.comment_status == 'account')) &&
            comment.status != 'close')
        }]" href="#" @click="replyToId = comment.id; replyMessage = undefined">Reply</a>
      <!-- reply block, with buttons -->
      <div class="replyTextareaContainer" v-if="replyToId">
        <span class="sentCommentersName margin-small--bottom">{{ $store.state.user.name }}</span>
        <div style="display: flex;
    align-items: center;
    justify-content: center;">
          <div v-for="(i, index) in pastedImage" :key="index" style="padding: 5px;position:relative">
            <button @click="deleteImg(index)"
              style="position: absolute; top:0; right: 0; background-color: #eee; transform: scale(0.5); transform-origin: top right"
              class="btn btn--close"></button>
            <img :src="i" />
          </div>
        </div>
        <textarea @paste="pasteFunction" placeholder="Add comment here..." class="textarea margin-small--bottom"
          v-model="replyMessage"></textarea>
        <div class="row textarea-buttons ">
          <a class="hrefButton--black" @click="replyToId = undefined">Cancel</a>
          <button class="btn btn-blue" @click="replyToComment()">Reply</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'comment',
  data: () => ({
    editMessage: undefined,
    statusMessage: undefined,
    commentToBeDeleted: undefined,
    replyToId: undefined,
    replyMessage: undefined,
    deleteConfirmDialogOpen: false,
    showAttachment: true,
    selectedAttachment: undefined,
    pastedImage: []

  }),
  props: ['comment', 'index', 'reply', 'accountView'],
  methods: {
    visibilityChanged(event) {
      if (event) {
        this.commentSeen();
      }
    },
    refreshBoard() {
      this.$parent.refreshBoard();
    },
    updateComment() {
      const _this = this;
      this.put(`comment/${_this.comment.id}`, {
        ..._this.comment,
        message: _this.editMessage
      }, {}, () => {
        _this.refreshBoard();
        _this.editMessage = undefined;
      }, () => {
        _this.statusMessage = 'Sikertelen modositas';
        setTimeout(() => {
          _this.statusMessage = undefined
        }, 3000);
      })
    },
    pasteFunction(pasteEvent, callback) {
      var _this = this;
      if (pasteEvent.clipboardData == false) {
        if (typeof (callback) == "function") {
          
          callback(undefined);
        }
      }

      var items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof (callback) == "function") {
          callback(undefined);
       
        }
      }
      for (var i = 0; i < items.length; i++) {

       
        if (items[i].type.indexOf("image") != -1) {

          var blob = items[i].getAsFile();
        
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function () {
            _this.pastedImage.push(reader.result);

          }
        }
      }

    },
    replyToComment() {
      var call = 0;
      const _this = this;
      this.post(`comment`, {
        message: this.replyMessage,
        user_id: this.$store.state.user.id,
        reply_to: this.replyToId,
        creative_id: this.comment.creative.id,
        time_position: 0,
        x_position: (this.$store.state.locationMode) ? this.$store.state.x_position : 0,
        y_position: (this.$store.state.locationMode) ? this.$store.state.y_position : 0,
      }, {}, (resp) => {
        _this.pastedImage.forEach((val) => {
          call++;
          _this.post('comment_attachment', {
            data: val,
            comment_id: resp.data.result.comment.id
          }, {}, function () {
            call--;
            if (call == 0) {
              if (_this.$parent.refreshBoard)
                _this.refreshBoard();
            }
          })
        });
        _this.refreshBoard();
        _this.replyMessage = undefined;
        _this.replyToId = undefined;
      }, () => {
        _this.statusMessage = 'Sikertelen válasz';
        setTimeout(() => {
          _this.statusMessage = undefined
        }, 3000);
      })
    },
    deleteComment(id) {
      const _this = this;
      this.delete(`comment/${id}`, {}, () => {
        // _this.statusMessage = 'Sikeres torles';
        // setTimeout(() => {
        //   _this.statusMessage = undefined
        // }, 3000);

        this.deleteConfirmDialogOpen = false
        this.commentToBeDeleted = undefined
        _this.refreshBoard()
      }, () => {
        _this.statusMessage = 'Sikertelen torles';
        setTimeout(() => {
          _this.statusMessage = undefined
        }, 3000);
      })
    },
    showHideExtra(){
      return;
      /*if (this.comment.x_position != 0 || this.comment.y_position)
      {
        this.showMarker()
      }
      if (this.comment.comment_attachment)
      {
        this.showDraw()
      }*/
    },
    showMarker() {
      this.$store.state.drawViewMode = false;
      if (this.$store.state.view_comment.id == this.comment.id) {
        this.$store.state.view_comment = false;
        this.$store.state.locationViewMode = false;
        return;
      }
      //console.log(this.comment)
      if (this.comment.x_position != 0 || this.comment.y_position) {
        this.$store.state.view_comment = this.comment;
        this.$store.state.locationViewMode = true;
        this.$store.state.x_position_view = this.comment.x_position;
        this.$store.state.y_position_view = this.comment.y_position;
      }
    },
    showDraw() {
      this.$store.state.locationViewMode = false;
      if (this.$store.state.view_comment.id == this.comment.id) {
        this.$store.state.view_comment = false;
        this.$store.state.drawViewMode = false;
        return;
      }
      //console.log(this.comment)
      if (this.comment.comment_attachment) {
        this.$store.state.view_comment = this.comment;
        this.$store.state.drawViewMode = true;
       
      }
    },
    mouseLeave() {
      this.$store.state.locationViewMode = false;
    },
    onCancel() {
      this.deleteConfirmDialogOpen = false
      this.commentToBeDeleted = undefined
      this.showAttachment = false
    },
    commentSeen() {
      var _this = this;
      if (this.comment.comment_seen) {

        if (this.comment.comment_seen.filter(element => { return element.user_id == _this.$store.state.user.id }).length > 0)
          return;
      }
      this.post('comment_seen', {
        comment_id: this.comment.id,
        payment_cluster_id : this.comment.payment_cluster_id,
        user_id: this.$store.state.user.id
      }, {}, function () {
        //_this.refreshBoard()
      });
    }
  },
}
</script>